import React from 'react';
import FolderFilesCountCell from 'shared/lib/extendedComponents/grids/components/folderFilesCountCell';
import GridRowContainer from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import DesktopSettingsCell from 'shared/lib/extendedComponents/grids/components/settingsCell/desktopSettingsCell';
import TextCell from 'shared/lib/extendedComponents/grids/components/textCell';
import { observer } from 'mobx-react-lite';
import SectionNameCell from 'shared/lib/extendedComponents/grids/components/sectionNameCell/sectionNameCell';
import { getAbsPath } from 'app/api/api';
import { ExplorerEntityTypes, ContentSectionItem } from 'entities/types';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import { DateManager } from 'shared/lib/utils/dateManager';
import { noValue } from 'shared/lib/utils/uiConstants';

export default observer(function ContentSectionRow({
  onClick,
  onEdit,
  onRestore,
  onDelete,
  isSettingsDisabled,
  supportTypes,
  data,
}: {
  onClick: () => void;
  onEdit?: () => void;
  onRestore?: () => void;
  onDelete?: () => void;
  isSettingsDisabled?: boolean;
  supportTypes: ExplorerEntityTypes[];
  data: ContentSectionItem;
}) {
  const { isLessLaptop } = useBooleanScreens();

  return isLessLaptop ? (
    <GridRowContainer onClick={onClick}>
      <SectionNameCell
        name={data.name}
        preview={getAbsPath(data.preview_url) || null}
      ></SectionNameCell>
      <span></span>
    </GridRowContainer>
  ) : (
    <GridRowContainer onClick={onClick}>
      <SectionNameCell
        name={data.name}
        preview={getAbsPath(data.preview_url) || null}
      ></SectionNameCell>
      <TextCell>{new DateManager(data.last_change_date).frontFormat}</TextCell>
      <TextCell>Секция</TextCell>
      {supportTypes.includes(ExplorerEntityTypes.FILE) ? (
        <TextCell>{noValue}</TextCell>
      ) : null}
      {isSettingsDisabled ? (
        <span></span>
      ) : (
        <DesktopSettingsCell
          onSettings={onEdit}
          onRestore={onRestore}
          onDelete={onDelete}
        ></DesktopSettingsCell>
      )}
    </GridRowContainer>
  );
});
